module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false,
      "before-close": _vm.close
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "跟进对象:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.objectName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跟进人:"
    }
  }, [_c('span', [_vm._v(_vm._s(this.$store.state.sysUserName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检测进度:"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "-请选择-"
    },
    on: {
      "change": _vm.changeModal
    },
    model: {
      value: (_vm.form.OptionId),
      callback: function($$v) {
        _vm.$set(_vm.form, "OptionId", $$v)
      },
      expression: "form.OptionId"
    }
  }, _vm._l((_vm.OptionTypes), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.OptionTitle
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检测结果:"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.form.CheckResultId),
      callback: function($$v) {
        _vm.$set(_vm.form, "CheckResultId", $$v)
      },
      expression: "form.CheckResultId"
    }
  }, _vm._l((_vm.CheckResult), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.OptionTitle
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    staticClass: "formLength",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.Remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "Remark", $$v)
      },
      expression: "form.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "footer"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f7ab795e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Network/networkCheck/components/followDialog/index.vue
// module id = 1585
// module chunks = 1